import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Subject} from 'rxjs/Subject';
import {AngularFirestore} from 'angularfire2/firestore';
import {PropertyDB} from '../../interfaces/property.interface';
import {DocumentChangeAction} from 'angularfire2/firestore/interfaces';
import {subscribeToResult} from 'rxjs/util/subscribeToResult';


@Injectable()

export class FirebasePropertyService {

  constructor(private afs: AngularFirestore) {

  }


  /**
   * Retrieve Property at Organization > Property
   * @param {string} org_id
   * @param {string} property_id
   * @returns {Observable<PropertyDB>}
   */
  getPropertyByOrgAndId(org_id: string, property_id: string): Observable<PropertyDB> {
    console.log(org_id, property_id);
    const property = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id);

    return property.valueChanges();
  }


  /**
   *
   * @param {string} org_id
   * @param {string} property_id
   * @param {string} document
   * @returns {Observable<PropertyDB>}
   */
  getPropertyListingFieldByOrgAndId(org_id: string, property_id: string, document: string): Observable<any> {
    console.log(org_id, property_id);
    const listingValue = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id)
      .collection('listing').doc(document);

    return listingValue.valueChanges();
  }


  /**
   *
   * @param {string} org_id
   * @param {string} property_id
   * @param {string} document
   * @param {string} field
   * @param {string} value
   * @returns {Promise<void>}
   */
  editPropertyListingFieldsByOrgAndId(org_id: string, property_id: string, document: string, field: string, value: string) {
    console.log(org_id, property_id);
    const property = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id)
      .collection('listing').doc(document);

    return this.fromFirebaseAuthPromise(property.set({
      [field]: value
    }));
  }


  /**
   *
   * @param {string} org_id
   * @param {string} property_id
   * @param formValue
   * @returns {Observable<any>}
   */
  editPropertyListingAmenatiesByOrgAndId(org_id: string, property_id: string, formValue: any) {
    console.log(org_id, property_id);
    const property = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id)
      .collection('listing').doc('amenities');

    return this.fromFirebaseAuthPromise(property.set(formValue));
  }


  /**
   *
   * @param {string} org_id
   * @param {string} property_id
   * @param formValue
   * @returns {Observable<{}>}
   */
  getPropertyListingAmenatiesByOrgAndId(org_id: string, property_id: string) {
    console.log(org_id, property_id);
    const property = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id)
      .collection('listing').doc('amenities');

    return property.valueChanges();
  }


  /**
   *
   * @param {string} org_id
   * @param {string} property_id
   * @param formValue
   * @returns {Observable<{}>}
   */
  getPropertyListingCustomAmenatiesByOrgAndId(org_id: string, property_id: string) {
    console.log(org_id, property_id);
    const property = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id)
      .collection('listing').doc('amenities').collection('other');

    return property.valueChanges();
  }


  addPropertyListingCustomAmenatiesByOrgAndId(org_id: string, property_id: string, name: string) {
    console.log(org_id, property_id);
    const property = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id)
      .collection('listing').doc('amenities').collection('other');

    return this.fromFirebaseAuthPromise(property.add({
        name: name,
        value: true
      })
    );
  }


  /**
   * Retrieve Property at Organization > Property
   * @param {string} org_id
   * @param {string} property_id
   * @returns {Observable<PropertyDB>}
   */
  updatePropertyAddressByOrgAndId(org_id: string, property_id: string, formValue): Observable<any> {
    console.log(org_id, property_id);
    const property = this.afs.collection('organizations')
      .doc(org_id).collection('properties').doc(property_id);

    return this.fromFirebaseAuthPromise(
      property.update({
        street: formValue.street,
        apt: formValue.apt,
        city: formValue.city,
        state: formValue.state,
        zip: formValue.zip
      }));
  }


  /**
   *
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  getPropertiesByUID(uid: string): Observable<any> {
    const list = this.afs.collection<any>('users').doc(uid).collection('properties'
      , ref => {
        return ref
          .where('active', '==', true);
      });
    return list.valueChanges();
  }


  /**
   *
   * @param {string} uid
   * @returns {Observable<DocumentChangeAction[]>}
   */
  getPropertyByIdAtUID(uid: string, property_id): Observable<any> {
    const property = this.afs.collection<any>('users').doc(uid).collection('properties').doc(property_id);
    //   , ref => {
    //   return ref
    //     .where(uid, '==', uid);
    // });
    return property.valueChanges();
  }


  // Convert Promise of Firebase to an Observable
  fromFirebaseAuthPromise(promise): Observable<any> {

    const subject = new Subject<any>();

    promise
      .then(res => {
          subject.next(res);
          subject.complete();
        },
        err => {
          subject.error(err);
          subject.complete();
        }
      );
    return subject.asObservable();
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/firebase/property.service.ts